module.exports = __webpack_public_path__ + "static/media/Gotham-Medium.27a90e87.otf";


/*****************
 ** WEBPACK FOOTER
 ** ./src/fonts/Gotham-Medium.otf
 ** module id = 1342
 ** module chunks = 0
 **/